module.exports = __webpack_public_path__ + "img/facebook.359801b0.svg";